const INCREMENT_COUNT = 'INCREMENT_COUNT';
const DECREMENT_COUNT = 'DECREMENT_COUNT';

export default {
    INCREMENT_COUNT,
    DECREMENT_COUNT,
}